import useTranslation from '@space-lib/hooks/useTranslation'
import { useInfiniteRequest } from '@space-shell/common/hooks/useInfiniteRequest'
import {
  CONTEXT,
  NotificationsEndpoints,
  NotificationsService,
  ROLE
} from '@space-shell/common/services/notifications'

export const useNotificationInfiniteRequest = () => {
  const {
    i18n: { language }
  } = useTranslation()

  return useInfiniteRequest(
    [NotificationsEndpoints.notifications()],
    ({ pageParam }) =>
      NotificationsService.getNotifications({
        language: language.toLocaleLowerCase(),
        role: ROLE.CONSUMER,
        context: CONTEXT.CLUB,
        nextToken: pageParam
      }),
    {
      getNextPageParam: (lastPage) => lastPage?.nextToken ?? undefined
    }
  )
}
